import React, { Component } from "react";
import { IonToolbar, IonButtons, IonSegment, IonSegmentButton, IonIcon, IonPopover, IonList, IonItem } from "@ionic/react";
import "./style.css";
import { Link } from "react-router-dom";
import Firebase from "../../firebase";
import { URLS } from "../../urls";
import { settingsSharp } from "ionicons/icons";
// import Firebase from "../../Firebase";
class Toolbar extends Component {
    state = {
        fb: Firebase.getInstance(),
        logged: false, // whether or not the user is logged in
        popoverOpen: false,
        data: {} as any,
    };

    _isMounted = true;

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        var user = await this.state.fb.getUser();
        if (user != null) {
            this.setState({ logged: true });
            const data = await this.state.fb.readData("users/public/$uid");
            if (!this._isMounted) return;
            this.setState({ data });
        }
    }
    signout = () => {
        // sign out of account
        this.state.fb.signout();
        window.location.pathname = URLS.LOGIN.url;
    };
    render() {
        return (
            <IonToolbar>
                <IonButtons slot="start">
                    <a href={URLS.SAFSAL.url} target="_blank" rel="noopener noreferrer">
                        <img className="toolbar__logo" src="assets/icon/logo2.png" alt="safsal logo" />
                        <img className="toolbar__icon" src="assets/icon/favicon.png" alt="safsal logo" />
                    </a>
                </IonButtons>
                <div style={{ overflowX: "scroll", overflow: "hidden" }}>
                    <IonSegment scrollable={true} value={window.location.pathname}>
                        <Link to={URLS.HOME.url}>
                            <IonSegmentButton value={URLS.HOME.url}>בית</IonSegmentButton>
                        </Link>
                        <Link to={URLS.MY_TEAM.url}>
                            <IonSegmentButton value={URLS.MY_TEAM.url} style={{ display: this.state.logged ? "flex" : "none" }}>
                                הנבחרת שלי
                            </IonSegmentButton>
                        </Link>
                        <Link to={URLS.PLAYOFF.url}>
                            <IonSegmentButton value={URLS.PLAYOFF.url} style={{ display: this.state.logged ? "flex" : "none" }}>
                                פלייאוף
                            </IonSegmentButton>
                        </Link>
                        <Link to={URLS.RULES.url}>
                            <IonSegmentButton value={URLS.RULES.url}>תקנון</IonSegmentButton>
                        </Link>
                        <Link to={URLS.LOGIN.url} style={{ display: this.state.logged ? "none" : "flex" }}>
                            <IonSegmentButton value={URLS.LOGIN.url}>התחברות</IonSegmentButton>
                        </Link>
                        <Link to={URLS.REGISTER.url} style={{ display: this.state.logged ? "none" : "flex" }}>
                            <IonSegmentButton value={URLS.REGISTER.url}>רישום</IonSegmentButton>
                        </Link>
                    </IonSegment>
                </div>
                <IonButtons slot="end" style={{ display: this.state.logged ? "flex" : "none" }}>
                    <IonIcon
                        className="toolbar__settings"
                        icon={settingsSharp}
                        onClick={() => {
                            this.setState({ popoverOpen: true });
                        }}
                    ></IonIcon>
                </IonButtons>

                <IonPopover
                    isOpen={this.state.popoverOpen}
                    cssClass="toolbar__popover"
                    onDidDismiss={(e) => {
                        if (!this._isMounted) return;
                        this.setState({ popoverOpen: false });
                    }}
                >
                    <IonList>
                        <IonItem className="toolbar__nickname">שלום {this.state.data.nickname}</IonItem>
                        <Link to={URLS.ACCOUNT.url}>
                            <IonItem>הגדרות</IonItem>
                        </Link>
                        <IonItem onClick={this.signout}>יציאה מהחשבון</IonItem>
                    </IonList>
                </IonPopover>
            </IonToolbar>
        );
    }
}
export default Toolbar;
